<!-- confirmation-modals.component.html -->
<div class="modal-overlay" [ngClass]="{'show': modalConfig.isOpen}" (click)="onBackdropClick($event)">
  <div class="modal-container" [ngClass]="[modalConfig.type, modalConfig.type === 'segment-review' ? ('action-' + selectedStatus) : '']">
    <div class="modal-header">
      <div class="modal-icon">
        <img [src]="getIconSrc()" alt="modal icon">
      </div>
      <h3 class="modal-title">{{ getModalTitle() }}</h3>
      <button class="modal-close" (click)="onCancel()">
        <span>&times;</span>
      </button>
    </div>
    
    <div class="modal-body">
      @if(modalConfig.type === 'segment-review') {
        <p class="modal-message">Please select the action for segment
          "<span class="modal-segment-name" [title]="modalConfig.segmentData?.name || ''">{{ modalConfig.segmentData?.name || 'Unknown' }}</span>"
          on The Trade Desk:
        </p>
      } @else {
        <p class="modal-message">{{ getModalMessage() }}</p>
      }

      @if(modalConfig.type === 'segment-review') {
        <div class="review-modal-content">
          <div class="section-head">Segment Details</div>
          <div class="segment-summary kv-grid">
            <div class="kv-item">
              <div class="kv-label">Segment</div>
              <div class="kv-value truncate" [title]="modalConfig.segmentData?.name || ''">{{ modalConfig.segmentData?.name || '-' }}</div>
            </div>
            <div class="kv-item">
              <div class="kv-label">Segment ID</div>
              <div class="kv-value">{{ modalConfig.segmentData?.segment_id || '-' }}</div>
            </div>
            <div class="kv-item">
              <div class="kv-label">Type</div>
              <div class="kv-value">{{ (modalConfig.segmentData?.segment_type || 'Standard') | uppercase }}</div>
            </div>
            <div class="kv-item">
              <div class="kv-label">Current Status</div>
              <div class="kv-value"><span class="status-chip">{{ (modalConfig.segmentData?.status || '-') | uppercase }}</span></div>
            </div>
          </div>

          <div class="content-pool-status-section">
            <app-content-pool-status [maxDisplayItems]="5"></app-content-pool-status>
          </div>

          <div class="section-head">Choose Action</div>
          <div class="option-grid" role="radiogroup" aria-label="Segment action">
            <label class="option-card activate-card" [class.selected]="selectedStatus === 'activate'">
              <input
                type="radio"
                name="segmentStatus"
                value="activate"
                [(ngModel)]="selectedStatus"
              >
              <div class="option-icon activate">
                <img src="assets/img/success.svg" alt="Approve" />
              </div>
              <div class="option-content">
                <div class="option-title">Approve Segment</div>
                <div class="option-desc">Activate and make this segment available on The Trade Desk.</div>
              </div>
            </label>

            <label class="option-card reject-card" [class.selected]="selectedStatus === 'reject'">
              <input
                type="radio"
                name="segmentStatus"
                value="reject"
                [(ngModel)]="selectedStatus"
              >
              <div class="option-icon reject">
                <img src="assets/img/cross.png" alt="Reject" />
              </div>
              <div class="option-content">
                <div class="option-title">Reject Segment</div>
                <div class="option-desc">Reject this segment. It will remain unavailable on TTD.</div>
              </div>
            </label>
          </div>
        </div>
      }
    </div>
    
    <div class="modal-footer">
      <button class="btn secondary" (click)="onCancel()">
        Cancel
      </button>
      <button class="btn" [ngClass]="getConfirmButtonClass()" (click)="onConfirm()">
        {{ getConfirmButtonText() }}
      </button>
    </div>
  </div>
</div>